import React from "react";
import { Modal, Form, Input, Divider, Button, Alert } from "antd";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "./dropdown.css";

const CaseModal = ({
  caseModalShow,
  setCaseModalShow,
  handleSubmit,
  typedCaseNumber,
  setTypedCaseNumber,
  handleCaseNumberFocus,
  handleCaseNumberChange,
  caseHistory,
  handleSearch,
  handleExistingCaseNumberChange,
  handleExistingCaseNumberFocus,
  showWarning,
  loading,
  existingCaseNumber,
}) => {
  return (
    <Modal
      title={<div style={{ color: "var(--bs-theme)" }}>Enter Case Number</div>}
      open={caseModalShow}
      onCancel={() => setCaseModalShow(false)}
      footer={null}
      centered
      maskClosable={false}
      keyboard={false}
      className="case-modal"
      styles={{
        mask: {
          backgroundColor: "rgba(0, 0, 0, 0.45)",
        },
        content: {
          backgroundColor: "rgb(29, 40, 53)",
          borderRadius: "8px",
        },
      }}
    >
      <Form onSubmit={handleSubmit}>
        <Form.Item label="Case Number">
          <Input
          className="white-placeholder"
            
            placeholder="Enter Case Number"
            value={typedCaseNumber}
            onChange={handleCaseNumberChange}
            onFocus={handleCaseNumberFocus}
          />
        </Form.Item>

        <Divider plain>OR</Divider>

        <Form.Item label="Select Existing">
          <AsyncTypeahead
            id="async-typeahead"
            className="white-placeholder"  // Add this
            isLoading={false}
            labelKey="caseNumber"
            onSearch={handleSearch}
            options={caseHistory}
            placeholder="Click or Type to Select Existing"
            onChange={handleExistingCaseNumberChange}
            onFocus={handleExistingCaseNumberFocus}
          />
        </Form.Item>

        {showWarning && !typedCaseNumber && !existingCaseNumber && (
          <Alert
            message="Please set a case number before submitting."
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}

        <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={loading}
            id="set-case-number"
          >
            Set Case Number
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CaseModal;
